import axios from "axios";

import { createAuthorizedClient, GOLDBOT_BASE_URL } from "./apiClient";

const goldBotClient = createAuthorizedClient({
  baseURL: GOLDBOT_BASE_URL,
  timeout: 4500,
});

export const GoldBotApiErrorKind = Object.freeze({
  UNAVAILABLE: "unavailable",
  NETWORK: "network",
  INVALID_RESPONSE: "invalid_response",
  REQUEST: "request",
});

export class GoldBotApiError extends Error {
  constructor(message, kind, cause) {
    super(message);
    this.name = "GoldBotApiError";
    this.kind = kind;
    this.cause = cause;
  }
}

export function isGoldBotRequestCanceled(error) {
  return axios.isCancel(error);
}

export async function getGoldBotStatus({ signal } = {}) {
  try {
    const response = await goldBotClient.get("/status", { signal });

    if (
      !response.data ||
      typeof response.data !== "object" ||
      Array.isArray(response.data) ||
      typeof response.data.goldbot_status !== "string" ||
      typeof response.data.stale !== "boolean"
    ) {
      throw new GoldBotApiError(
        "GoldBot returned an invalid status response.",
        GoldBotApiErrorKind.INVALID_RESPONSE
      );
    }

    return response.data;
  } catch (error) {
    if (isGoldBotRequestCanceled(error) || error instanceof GoldBotApiError) {
      throw error;
    }

    if (error.response?.status === 503) {
      throw new GoldBotApiError(
        "GoldBot status is unavailable.",
        GoldBotApiErrorKind.UNAVAILABLE,
        error
      );
    }

    if (!error.response) {
      throw new GoldBotApiError(
        "Could not reach the GoldBot API.",
        GoldBotApiErrorKind.NETWORK,
        error
      );
    }

    throw new GoldBotApiError(
      "GoldBot status request failed.",
      GoldBotApiErrorKind.REQUEST,
      error
    );
  }
}
